import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="arxiv-preview"
//
// The device preview beside the comparison. Both screens are already in the
// page, so a press only decides which one is showing — the visitor never waits
// for an image to arrive, and the frame never resizes under their thumb.
//
// How the two screens change places is the stylesheet's business. This says
// only which one is off, so pressing both in quick succession lands on whatever
// was pressed last with nothing left half-done.
export default class extends Controller {
  static targets = ["formatButton", "pdf", "epub"]

  connect() {
    // Turbo restores this page from its cache with whatever was pressed last
    // still pressed. The preview is an argument, not a setting, so it opens on
    // PDF every time.
    this.format = "pdf"
    this.mark()
    this.draw()
  }

  select({ params: { format } }) {
    if (format === this.format) return

    this.format = format
    this.mark()
    this.draw()
  }

  // The labels, and through the data attribute the block that slides between
  // them.
  mark() {
    this.formatButtonTargets.forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.arxivPreviewFormatParam === this.format))
    })
    this.element.dataset.format = this.format
  }

  draw() {
    const epub = this.format === "epub"

    this.pdfTarget.classList.toggle("arxiv-preview__page--off", epub)
    this.epubTarget.classList.toggle("arxiv-preview__page--off", !epub)
  }
}
